import { render, staticRenderFns } from "./ObjectEditor.vue?vue&type=template&id=6091749e&scoped=true&lang=pug"
import script from "./ObjectEditor.vue?vue&type=script&lang=js"
export * from "./ObjectEditor.vue?vue&type=script&lang=js"
import style0 from "./ObjectEditor.vue?vue&type=style&index=0&id=6091749e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6091749e",
  null
  
)

export default component.exports